import React, { useContext, useEffect, useRef, useState } from 'react';
import { AuthContext } from '../../../common/constants';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Avatar, Badge } from 'antd';
import { demandeAssistancesService } from '../../../common/services';
import { io } from 'socket.io-client';
import { useLayout } from '../LayoutContext';

// const socket = io('http://localhost:8081');
const socket = io('https://api.tigoon-connect.com/api/v1');

const Navbar = () => {
    const auth = useContext(AuthContext);
    const { currentUser } = auth;
    const { toggleSidebar } = useLayout();

    const [pendingCount, setPendingCount] = useState(0);
    const previousCountRef = useRef(0);

    // helper pour extraire un tableau depuis différentes formes de réponse
    const toArray = (res) => {
        if (Array.isArray(res)) return res;
        if (Array.isArray(res?.items)) return res.items;            // <-- ICI
        if (Array.isArray(res?.data)) return res.data;
        if (Array.isArray(res?.data?.items)) return res.data.items; // <-- ICI
        if (Array.isArray(res?.data?.data)) return res.data.data;
        if (Array.isArray(res?.results)) return res.results;
        if (Array.isArray(res?.payload)) return res.payload;
        return [];
    };


    useEffect(() => {
        const checkNewDemandes = async () => {
            try {
                const res = await demandeAssistancesService.get();
                // console.log('get() retourne :', res);
                const allDemandes = toArray(res);
                const enAttente = allDemandes.filter(d => d?.statut === 'en_attente');

                if (enAttente.length > previousCountRef.current) {
                    const nouvelles = enAttente.length - previousCountRef.current;
                    toast.info(`📨 ${nouvelles} nouvelle(s) demande(s) d’assistance !`, {
                        position: "top-right",
                        autoClose: 5000,
                    });
                }

                setPendingCount(enAttente.length);
                previousCountRef.current = enAttente.length;
            } catch (err) {
                console.error('Erreur lors du contrôle des demandes :', err);
            }
        };

        checkNewDemandes();
        const interval = setInterval(checkNewDemandes, 15000);
        return () => clearInterval(interval);
    }, []);


    useEffect(() => {
        const onNouvelle = async () => {
            try {
                const res = await demandeAssistancesService.get();
                const allDemandes = toArray(res);
                const enAttente = allDemandes.filter(d => d?.statut === 'en_attente');
                setPendingCount(enAttente.length);
                toast.info("📨 Nouvelle demande d’assistance reçue !");
            } catch (e) {
                console.error(e);
            }
        };

        socket.on('nouvelle-demande', onNouvelle);
        return () => socket.off('nouvelle-demande', onNouvelle);
    }, []);

    useEffect(() => {
        const onUpdated = async () => {
            try {
                const res = await demandeAssistancesService.get();
                const allDemandes = toArray(res);
                const enAttente = allDemandes.filter(d => d?.statut === 'en_attente');
                setPendingCount(enAttente.length);
            } catch (e) {
                console.error(e);
            }
        };

        socket.on('demande_assistance_updated', onUpdated);
        return () => socket.off('demande_assistance_updated', onUpdated);
    }, []);



    return (
        <>
            <nav
                className="layout-navbar container-xxl navbar navbar-expand-xl navbar-detached align-items-center bg-navbar-theme"
                id="layout-navbar"
            >
                {/* Burger visible < XL */}
                <div className="layout-menu-toggle navbar-nav align-items-xl-center me-3 me-xl-0 d-xl-none">
                    <button
                        className="nav-item nav-link px-0 me-xl-4 btn btn-link"
                        type="button"
                        aria-label="Ouvrir le menu"
                        onClick={toggleSidebar}
                    >
                        <i className="bx bx-menu bx-sm" />
                    </button>
                </div>

                <div className="navbar-nav-right d-flex align-items-center" id="navbar-collapse">
                    {/* Search */}
                    <div className="navbar-nav align-items-center">
                        <div className="nav-item d-flex align-items-center">
                            <i className="bx bx-search fs-4 lh-0" />
                            <input
                                type="text"
                                className="form-control border-0 shadow-none"
                                placeholder="Search..."
                                aria-label="Search..."
                            />
                        </div>
                    </div>

                    <ul className="navbar-nav flex-row align-items-center ms-auto">
                        <li className="nav-item me-4">
                            <Badge
                                count={Number(pendingCount) || 0}
                                showZero
                                overflowCount={9999}
                                offset={[6, -2]}
                                size="small"
                                styles={{ indicator: { zIndex: 10 } }}
                            >
                                <span className="position-relative d-inline-flex" style={{ lineHeight: 0 }}>
                                    <i className="bx bx-bell fs-4" />
                                </span>
                            </Badge>
                        </li>

                        <li className="nav-item lh-1 me-3" style={{ textTransform: 'uppercase' }}>
                            {currentUser ? `${currentUser.firstName} ${currentUser.lastName}` : 'Chargement...'}
                        </li>

                        <li className="nav-item navbar-dropdown dropdown-user dropdown">
                            <Link className="nav-link dropdown-toggle hide-arrow" to="javascript:void(0);" data-bs-toggle="dropdown">
                                <Avatar
                                    size={40}
                                    src={currentUser?.photoUrl}
                                    style={{ backgroundColor: '#8e5616', verticalAlign: 'middle' }}
                                >
                                    {currentUser ? `${currentUser.firstName[0]}${currentUser.lastName[0]}`.toUpperCase() : ''}
                                </Avatar>
                            </Link>

                            <ul className="dropdown-menu dropdown-menu-end">
                                <li>
                                    <Link className="dropdown-item" to="#">
                                        <div className="d-flex">
                                            <div className="flex-shrink-0 me-3">
                                                <Avatar
                                                    size={40}
                                                    src={currentUser?.photoUrl}
                                                    style={{ backgroundColor: '#8e5616', verticalAlign: 'middle' }}
                                                >
                                                    {currentUser ? `${currentUser.firstName[0]}${currentUser.lastName[0]}`.toUpperCase() : ''}
                                                </Avatar>
                                            </div>
                                            <div className="flex-grow-1">
                                                <span className="fw-semibold d-block" style={{ textTransform: 'uppercase' }}>
                                                    {currentUser ? `${currentUser.firstName} ${currentUser.lastName}` : 'Chargement...'}
                                                </span>
                                                <small className="text-muted">
                                                    {currentUser?.role === 'superAdmin' ? 'Super Administrateur' : 'Administrateur'}
                                                </small>
                                            </div>
                                        </div>
                                    </Link>
                                </li>

                                <li><div className="dropdown-divider" /></li>

                                <li>
                                    <Link className="dropdown-item" to="/dashboard/profile">
                                        <i className="bx bx-user me-2" />
                                        <span className="align-middle">Mon Profile</span>
                                    </Link>
                                </li>

                                <li><div className="dropdown-divider" /></li>

                                <li>
                                    <Link
                                        className="dropdown-item"
                                        to="#"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            toast.success("Déconnexion réussie", { position: "top-right", autoClose: 2000 });
                                            setTimeout(() => auth.onLogout(), 1000);
                                        }}
                                    >
                                        <i className="bx bx-power-off me-2" />
                                        <span className="align-middle">Se déconnecter</span>
                                    </Link>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </nav>
        </>
    );
};

export default Navbar;
